import { Card, Button } from 'react-bootstrap';
import AlertMessage from '../../../Alert';
import InputMask from 'react-input-mask';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { useContext, useState } from 'react';
import { CadastroContext } from '../../../../contexts/CadastroContext';

const AsoCnae = () => {
    const navigate = useNavigate();
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
    const [isDisabled, setIsDisabled] = useState(true);
    const [cnae, setCnae] = useState('');

    const handleContinuar = () => {
        if (cnae) {
            cadastro.cnae = cnae;
            handleCadastroChange(cadastro);
            return navigate("/aso/registro/endereco-empresa");
        }
    }

    const handleVoltar = () => {
        return navigate("/aso/registro/razao-social");
    }

    const handleCnae = (event: any) => {
        const value = event.target.value;
        const cnaeInput = value.replace(/\D/g, '');
        if (cnaeInput.length === 7) {
            setCnae(value);
            setIsDisabled(false);
        }
    }
    
    return(
        <>
            <div className='aso-container-cnae'>
                <div className='aso-titulo-container-cnae'>
                    <div className="aso-titulo-cnae">Qual é o CNAE da empresa?</div>
                </div>
                <div className='aso-container-card-cnae'>
                    <Card className='aso-card-cnae'>
                        <div className='aso-card-content-container-cnae'>
                            <div className='aso-inputs-row'>
                                <div className='aso-card-content-cnae'>
                                    <label htmlFor="cep" className='label-container'>
                                        <span className='aso-card-content-cnae-label-span'>CNAE</span>
                                    </label>
                                    <div className='aso-card-content-container-cnae-input'>
                                        <InputMask
                                            mask="9999-9/99"
                                            type="text"
                                            pattern="[0-9]*"
                                            id='cnae'
                                            title='Digite o CNAE'
                                            className='aso-card-content-cnae-input'
                                            onChange={(e: any) => handleCnae(e)}/>
                                    </div>
                                    <div className='aso-card-content-cnae-input-span'>
                                        <span>Insira apenas números, sem traços nem pontos.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                    <div className='aso-button-cnae-container'>
                        <Button variant="primary" className='aso-button-cnae-content' onClick={handleVoltar}>
                            Voltar
                        </Button>
                        <Button variant="primary" className='aso-button-cnae-content' onClick={handleContinuar} disabled={isDisabled}>
                            Continuar
                        </Button>
                    </div>
                </div>
            </div>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );
}

export default AsoCnae;